import { ServiceModelRoot } from '../service-model-root';

export class SampleServiceModelBase<T> extends ServiceModelRoot<T> {
}
